import { render, staticRenderFns } from "./CarefullyChosenItem.vue?vue&type=template&id=315a7691&scoped=true&"
import script from "./CarefullyChosenItem.vue?vue&type=script&lang=js&"
export * from "./CarefullyChosenItem.vue?vue&type=script&lang=js&"
import style0 from "./CarefullyChosenItem.vue?vue&type=style&index=0&id=315a7691&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a7691",
  null
  
)

export default component.exports